import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import tw from "twin.macro";

const Container = tw.div`max-w-2xl mx-auto px-6 py-24 text-center`;
const Heading = tw.h1`text-4xl md:text-5xl font-black text-primary-900 leading-snug`;
const Subheading = tw.p`mt-6 text-lg text-gray-600 leading-relaxed`;
const BackLink = tw(Link)`mt-10 inline-block px-8 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-700 transition duration-300`;

export default function ThankYouPage() {
  return (
    <AnimationRevealPage disabled>
      <Helmet>
        <title>Thank You | EthosHub</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <Container>
        <Heading>Thanks for getting in touch.</Heading>
        <Subheading>
          We've received your message and will get back to you shortly.
          <br />
          In the meantime, feel free to explore the site.
        </Subheading>
        <BackLink to="/">Back to home</BackLink>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}
